import React, { useEffect, useState } from 'react';
import { db } from 'src/config/firebase';
import QuizWrapper from './QuizWrapper';
import QuizReportPdf from './QuizReportPdf';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { Replay } from '@mui/icons-material';
import withRouter from 'src/config/withRouter';
import './quiz.css';
import moment from 'moment';
import CustomResultPage from './CustomResultPage';
import NoFoundImg from 'src/assets/images/quiz/notFound.png';
import QuizAlreadyAttempt from 'src/assets/images/quiz/alreadyAttempt.png';

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const useStyles = makeStyles((theme) => ({
    mainContainer:{
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        width: 'calc(100% - 44px)',
        boxShadow: '0px 3px 6px #00000029',
        backgroundColor: '#fff',
        padding: '20px 12px',
        minHeight: 'calc(241px - 44px)',
        borderRadius: '10px',
        margin:'auto'
    },

    loaderCont:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center'
    },

    loadingQuizSpan:{
        animation: `$fade 1s infinite`,
        paddingTop:'10px',
        color:'#0F467A',
        fontWeight: 400
    },

    '@keyframes fade': {
        '50%': {
            opacity: 0.5,
        }
    },

    notFoundImg:{
        '& img':{
            height:'100%',
            maxHeight:'100px'
        }
    },

    btnsDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%',
        marginTop:'20px',
        [theme.breakpoints.between('xs','md')]: {
            padding:'0px 10px',
            marginTop:'11px',
            width:'calc(100% - 20px)'
        }
    },

    prevNextBtn:{
        backgroundColor:'#0F467A',
        color:'#fff',
        textAlign:'center',
        height:'37px',
        minWidth:'96px',
        boxShadow:'0px 3px 6px #00000029',
        border:'none',
        borderRadius:'5px',
        textTransform:'capitalize',
        cursor:'pointer',
        outline:'none',
    },
}));

function QuizRender(props) {
    const { t, i18n, quizId, contentLogs, content, company, nextPrevBtnEvent, nextContentId, prevContentId, singleSession } = props;
    const companyId = company?.id || '';
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const classes = useStyles();
    const currentTime = moment().unix();
    const params = useParams()
    const resId = params.id ? params.id : '';
    const [kidName,setKidName] = useState('');
    const [kidLoading,setKidLoading] = useState(true);
    const [quiz,setQuiz] = useState({});
    const [quizLoading,setQuizLoading] = useState(true);
    const [questions,setQuestions] = useState([]);
    const [questionLoading,setQuestionLoading] = useState(true);
    const [firstAttempt,setFirstAttempt] = useState(false);
    const [showPrevNextBtn,setShowPrevNextBtn] = useState(false);
    const activeContentLog = contentLogs.filter(v=> v.contentId === content?.id)?.[0] || {};
    const { completed, resultId, attempt, id: activeContentId, updatedAt, quizSource } = activeContentLog || {};

    useEffect(()=> {
        moment.locale(isRTL);
    },[isRTL])

    useEffect(()=> {
        getQuiz();
        getQuestions();

        return ()=> {
            setQuiz({});
            setQuizLoading(true);
            setQuestions([]);
            setQuestionLoading(true);
            setFirstAttempt(false);
            setShowPrevNextBtn(false);
        }

    },[quizId]);

    useEffect(()=> {

        getKidName();

    },[resId]);

    function getKidName() {
        if(resId) {
            setKidLoading(true);
            db.ref(`Reservations/${resId}/kidName`).once('value',(data)=> {
                const kidName = data.val();
                if(kidName) {
                    setKidName(kidName);
                    setKidLoading(false);
                }
                else{
                    setKidName('');
                    setKidLoading(false);
                }
            })
            .catch(e=> {
                setKidName('');
                setKidLoading(false);
            })
        };
    };

    function getQuiz() {
        if(quizId) {
            setQuizLoading(true);
            db.ref(`Quizzes/${quizId}`).once('value',(data)=> {
                const res = data.val();
                
                if(res && res?.id) {
                    setQuiz(res);
                    setTimeout(()=> setQuizLoading(false),2000)
                }
                else{
                    setQuiz({});
                    setQuizLoading(false);
                }
            })
            .catch(e=> {
                setQuiz({});
                setQuizLoading(false);
            })
        };
    };

    function getQuestions() {
        if(quizId) {
            setQuestionLoading(true);
            db.ref(`QuizQuestions/`).orderByChild('quizId').equalTo(quizId).once('value',(data)=> {
                const res = data.val();

                if(res && Object?.keys(res)?.length) {
                    let questions = Object?.values(res)?.map(v=> ({
                        question: v.question,
                        questionType: v.questionType,
                        questionPic: v?.questionPic || '',
                        answerSelectionType: v.answerSelectionType,
                        answers: v.answers?.length ? v?.answers.filter(v=> v) : [],
                        correctAnswer: v.correctAnswer,
                        explanation: v.explanation,
                        explanationPic: v.explanationPic || '',
                        point: v.point
                    }));                
                    setQuestions(questions);
                    setTimeout(()=> setQuestionLoading(false),2000)
                }
                else{
                    setQuestions([]);
                    setQuestionLoading(false);
                }
            })
            .catch(e=> {
                setQuestions([]);
                setQuestionLoading(false);
            })
        };
    };

    const nextBackClickEvent = (contentId) => {
        setQuiz({});
        setQuizLoading(true);
        setQuestions([]);
        setQuestionLoading(true);
        setFirstAttempt(false);
        setShowPrevNextBtn(false);
        if(contentId) nextPrevBtnEvent(contentId);
    }

    const quizObj = {
        "quizTitle": quiz?.name || "",
        "nrOfQuestions": questions?.length || "0",
        "questions": questions || []
    };

    const setQuizResult = async (obj) => {
        let promise = [];
        const { minScore } = quiz || {};
        const _minScore = minScore ? Number(minScore) : 0;

        let copyObj = Object.assign({},obj);

        const isCompleted = copyObj.correctPoints >= _minScore;

        copyObj.userInput = copyObj.userInput.filter((value) => value !== undefined);

        if(isNaN(copyObj.timeTaken) || copyObj.timeTaken === null) {
            delete copyObj.timeTaken;
        };
        
        if(contentLogs?.length && content?.id) {
            const resultId = (await db.ref('QuizResults').push()).key;
            const nodeId = contentLogs.filter(v=> v.contentId === content?.id)?.[0]?.['id'] || '';
            const prevResultId = contentLogs.filter(v=> v.contentId === content?.id)?.[0]?.['resultId'] || '';
            const prevAttempt = contentLogs.filter(v=> v.contentId === content?.id)?.[0]?.['attempt'] || 0;

            const resultObj = {
                id: resultId,
                ...copyObj,
                courseId: content?.courseId,
                contentId: content?.id,
                quizId: content?.quizId,
                companyId,
                completedAt: currentTime,
                attempt: prevAttempt + 1,
                updatedAt: currentTime,
                reservationId: resId,
                kidName: kidName || ''
            };

            setFirstAttempt(true);
            setShowPrevNextBtn(true);
            promise.push(db.ref(`ContentLogs/${nodeId}/`).update({completed:isCompleted,...(!prevResultId ? {resultId:resultId} : {}), contentType:'quiz', attempt: prevAttempt+ 1,quizSource:copyObj,completedAt: currentTime,updatedAt:currentTime}));
            if(prevResultId) {
                promise.push(db.ref(`QuizResults/${prevResultId}/`).update({...copyObj,attempt: prevAttempt + 1,updatedAt: currentTime,reservationId:resId,kidName:kidName}))
            }
            else{
                promise.push(db.ref(`QuizResults/${resultId}/`).set(resultObj));
            };

            return Promise.all(promise);
        };
    };

    const reAttemptEvent = async () => {
        setShowPrevNextBtn(false);
        setFirstAttempt(false);
        getQuiz();
        getQuestions();
        db.ref(`ContentLogs/${activeContentId}/`).update({completed:false,reAttemptAt:currentTime});
    };
    return (
        (<div className={`${classes.mainContainer} ${quiz?.duration ? 'timer' : ''}`} style={{fontFamily}}>
            {quizLoading || questionLoading || kidLoading ? 
                <div className={classes.loaderCont}>
                    <ColorCircularProgress />
                    <span className={classes.loadingQuizSpan} style={{fontFamily}}>{t('quiz.loadingQuiz')}</span>
                </div>
            :
            completed && !firstAttempt ?
                <div className={classes.loaderCont}>
                    <div className={classes.notFoundImg}>
                        <img src={QuizAlreadyAttempt} alt='no quiz' />
                    </div>
                    <span className={classes.loadingQuizSpan} style={{fontFamily,color:'#adc0da',animation:'unset',fontWeight:600}}>{t('quiz.alreadyAttempt')}</span>
                    {quizSource && quiz && kidName ?
                    <QuizReportPdf  
                        quizData={quizSource}
                        quiz={quiz}
                        attempt={attempt}
                        date={updatedAt}
                        kidName={kidName}
                    />
                    : null}
                    {attempt < quiz.trial ?
                    <button type="button" className='attemptBtn' style={{fontFamily,alignSelf:'center'}} onClick={reAttemptEvent}>
                        <Replay />
                        <span style={{fontFamily,margin:'0px 5px'}}>{t('quiz.reAttempt')}</span>
                    </button>
                    : null}
                </div>
            :
            !quizLoading && !questionLoading && !kidLoading && questions?.length ?
                <QuizWrapper
                    quiz={quizObj}
                    shuffle={quiz?.shuffle || false}
                    showDefaultResult={false}
                    customResultPage={(obj)=> renderCustomResultPage({obj,quiz,attempt,reAttemptEvent,kidName})}
                    onComplete={setQuizResult}
                    {...{
                        ...(quiz.duration ? {timer:quiz.duration} : {})
                    }}
                />
            : 
            <div className={classes.loaderCont}>
                <div className={classes.notFoundImg}>
                    <img src={NoFoundImg} alt='no quiz' />
                </div>
                <span className={classes.loadingQuizSpan} style={{fontFamily,color:'#adc0da',animation:'unset',fontWeight:600}}>{t('quiz.noQuiz')}</span>
            </div>
            }
            {showPrevNextBtn ?
            <div className={classes.btnsDiv}>
                <button style={{fontFamily,opacity:!prevContentId ? 0.4 : 1, cursor: !prevContentId ? 'not-allowed' : 'pointer',...(!singleSession ? {pointerEvents:'none'} : {})}} className={classes.prevNextBtn} onClick={()=> nextBackClickEvent(prevContentId)}>{isRTL === 'ar' ? '< Previous' : '< Previous'}</button>
                <button style={{fontFamily,opacity:!nextContentId ? 0.4 : 1, cursor: !nextContentId ? 'not-allowed' : 'pointer',...(!singleSession ? {pointerEvents:'none'} : {})}} className={classes.prevNextBtn} onClick={()=> nextBackClickEvent(nextContentId)}>{isRTL === 'ar' ? 'Next >' : 'Next >'}</button>
            </div>
            : null}
        </div>)
    );
}


const mapStateToProps = state => {
    return {
        user: state.user,
        company: state.company,
        lang:state.lang,
        singleSession: state.singleSession,
    };
};

export default withRouter(connect(mapStateToProps,null)(withTranslation('common')(QuizRender)));

const renderCustomResultPage = ({obj,quiz,attempt,reAttemptEvent,kidName}) => {
    return(
        <CustomResultPage obj={obj} quiz={quiz} attempt={attempt} reAttemptEvent={reAttemptEvent} kidName={kidName} />
    )
}